import styles from './Mbn.module.css';
import { getMbnColor } from '../../../utils/render';
import React from 'react';

const Mbn = ({ mbn }) => {
    return (
        <div
            className={styles.mbn}
            style={{
                backgroundColor: getMbnColor(mbn),
            }}
        >
            {mbn}
        </div>
    );
};

export default Mbn;
